import {
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Text,
  useDisclosure,
  Image,
  Stack,
  Link,
  VStack
} from '@chakra-ui/react'
import { useTranslation } from 'react-i18next'
import { domainConfig } from '../utils/domainConfig'

const ApiManual = () => {
  const { t } = useTranslation()
  const { isOpen, onOpen, onClose } = useDisclosure()
  
  // Get manual images based on language
  const isEnglish = domainConfig.language === 'en'
  const manualImages = isEnglish 
    ? [
        '/images/manual_en_1.png',
        '/images/manual_en_2.png',
        '/images/manual_en_3.png',
        '/images/manual_en_4.png',
        '/images/manual_en_5.png',
        '/images/manual_en_6.png'
      ]
    : ['/images/manual.png']

  return (
    <>
      <Button
        size="sm"
        variant="outline"
        colorScheme="purple"
        onClick={onOpen}
        w="100%"
      >
        {t('View API Setup Guide')}
      </Button>

      <Modal isOpen={isOpen} onClose={onClose} size="xl" isCentered scrollBehavior="inside">
        <ModalOverlay />
        <ModalContent maxH="90vh">
          <ModalHeader>{t('API Key Registration Guide')}</ModalHeader>
          <ModalCloseButton />
          <ModalBody pb={6}>
            <Stack spacing={4}>
              <Text fontSize="sm" color="gray.600">
                {t(
                  'To create an API key, you need to register Google OTP and set a fund password first. Please register on the security settings page below.'
                )}
              </Text>

              <Link
                href="https://www.gate.com/myaccount/security-setting"
                color="purple.500"
                fontWeight="bold"
                isExternal
              >
                {t('🔒 Security Settings (Google OTP / Fund Password)')}
              </Link>

              <Text fontSize="sm" color="gray.600">
                {t(
                  'Click the link below to go to the Gate exchange API key creation page.'
                )}
              </Text>

              <Link
                href="https://www.gate.com/myaccount/profile/api-key/save"
                color="purple.500"
                fontWeight="bold"
                isExternal
              >
                {t('👉 Go to Gate API Key Creation')}
              </Link>

              <VStack spacing={4} align="stretch">
                {manualImages.map((src, index) => (
                  <Image
                    key={index}
                    src={src}
                    alt={`${t('API Key Setup Guide Image')} ${index + 1}`}
                    borderRadius="md"
                    boxShadow="sm"
                  />
                ))}
              </VStack>
            </Stack>
          </ModalBody>

          <ModalFooter>
            <Button onClick={onClose} colorScheme="gray">
              {t('Close')}
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  )
}

export default ApiManual


